<template>
  <div>
    <BusinessViewHeader
      :business="business"
      :is_loading="is_loading"
      :is_owner="is_owner"
      :is_on_details_view="false"
    ></BusinessViewHeader>
    <CardedSectionHeader
      icon="mdi-form-map"
      label="Upload Your Business Photoes "
      id="owner_view_gallery_edit_form"
    ></CardedSectionHeader>
    <CardedForm
      ref="edit_gallery_form_ref"
      id="edit_gallery_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <ImageField
        label="Business Image"
        icon="mdi-camera"
        :disabled="is_loading"
        folder="businessphotos"
        @on-hide-loader="hide_loader"
        @on-show-loader="show_loader"
        @on-success="on_finished_file_upload"
        @on-error="on_file_upload_errors"
        ref="upload_business_image_file_uploader"
        :required="true"
        empty_file_error="Please select an image to upload"
        :default_value="''"
      >
      </ImageField>

      <TextField
        v-model="form.description"
        :validation_rules="form_validations.description"
        label="Image Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Images List Preview"
      id="owner_view_remove_images_section"
    ></CardedSectionHeader>
    <v-row
      v-for="(photo, index) in business_images"
      :key="index"
      class="pa-5 pt-2 white"
    >
      <v-col cols="6">
        <v-img
          :src="photo.url"
          :alt="'business photo #' + photo.id"
          class="grey darken-4"
          height="200px"
        >
        </v-img>
      </v-col>
      <v-col cols="6" >
        <div class="greyx d-flex flex-column justify-space-between text-left" style="height:200px" >
          <div class="mb-5"><b>Photo ID: </b> #{{photo.id}}</div>
          <div class="mt-5">
            <TextArea 
                label="Edit Photo Description"
                v-model="photo.title"
                :validation_rules="form_validations.description_edit"
                icon="mdi-pen-plus"
                :disabled="is_loading"
              ></TextArea>
          </div> 
        </div> 
      </v-col>
      <v-col>
        <div class="d-flex  justify-space-between align-center mb-2">
          <v-btn
            color="red darken-1 white--text"
            class="hgt-40 round-4 mt-2 mb-2"
            tile
            filled
            ripple
            @click="delete_photo(photo)"
          >
            <v-icon left>mdi-trash-can</v-icon> Delete Photo
          </v-btn>

          <v-btn
            color="primary darken-1"
            class="hgt-40 round-4"
            tile
            filled
            ripple
            @click="update_photo_description(photo)"
            >Update Description</v-btn
          >
        </div>
        <v-divider></v-divider>
      </v-col>
    </v-row>
  </div>
</template>



<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import BusinessViewHeader from "./../../../components/BusinessViewHeader";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedForm from "../../../components/CardedForm";
import ImageField from "../../../components/ImageField";
import TextField from "../../../components/TextField";
import TextArea from "../../../components/TextArea";
export default {
  name: "OwnerBusinessesManageGallery",
  components: {
    BusinessViewHeader,
    CardedSectionHeader,
    CardedForm,
    ImageField,
    TextField,
    TextArea,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      business_id: 0,
      business: Utils.get_default_business(),
      is_owner: false,
      _user: null,
      errors: [],
      message: "",
      form: {
        picture: "",
        description: "",
      },
      form_validations: {
        description: [
          Utils.validate.max_length(
            400,
            "Your photo description should be less than 200 characters"
          ),
        ],
        description_edit: [
          Utils.validate.max_length(
            150,
            "Your photo description should be less than 10 characters"
          ),
        ]
      },
    };
  },
  methods: {
    on_auto_fill() {
      this.init_form();
    },
    init_form() {
      this.form.picture = "";
      this.form.description = "";
      this.errors = [];
      this.message = "";
    },
    load_business(id) {
      this.$emit("on-show-loader");
      ServerClient.Businesses.get_my_business(
        {
          id: id,
          user_id: this._user.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          if (res) {
            this.business = res;
            if (
              this._user &&
              this._user != null &&
              parseInt(this._user.id) == parseInt(this.business.user_id)
            ) {
              this.is_owner = true;
            }
            this.init_form();
            //nyd
            //if they are not the owner
            //show them a message of not authorised
            //then redirect them to the login screen
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.$refs.edit_gallery_form_ref.show_error_dialog();
        }
      );
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_finished_file_upload(file_url) {
      this.form.picture = file_url;
      this.update_business();
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.edit_gallery_form_ref.show_error_dialog();
    },
    submit() {
      this.$refs.upload_business_image_file_uploader.upload_file();
    },
    update_business() {
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.post_business_photo(
        {
          ...this.form,
          business_id: this.business_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/> Your photo has been uploaded successfully";
          this.$refs.edit_gallery_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_gallery_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      this.load_business(this.business_id);
    },
    update_photo_description(photo){
      this.errors = [];
      this.message = "";
      // console.log("Photoes to edit is:", photo);

      //do some simple validations
      var va = this.form_validations.description_edit[0];
      var res = va(photo.title);
      if(res !== true){
        this.errors = [res];
        this.$refs.edit_gallery_form_ref.show_error_dialog();
        return false;
      }
      
      this.$emit("on-show-loader");
      ServerClient.Businesses.update_business_photo_description(
        {
          id: photo.id,
          description :  photo.title,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/> Your photo description has been updated successfully";
          this.$refs.edit_gallery_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_gallery_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    delete_photo(photo){
      this.errors = [];
      this.message = "";
      
      
      this.$emit("on-show-loader");
      ServerClient.Businesses.delete_business_photo(
        {
          id: photo.id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/> Your photo was deleted successfully";
          this.$refs.edit_gallery_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.edit_gallery_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
  },
  computed: {
    business_images() {
      var list = [];
      if (this.business && this.business.pictures) {
        for (var index = 0; index < this.business.pictures.length; index++) {
          var pic = this.business.pictures[index];
          list.push({
            id: pic.id,
            title: pic.description,
            url: pic.media_url,
            business_id: pic.business_id,
          });
          //{title:'Image1',url:'http://xxx.com/1.jpg'},
        }
      }
      return list;
    },
  },
  mounted() {
    //   console.log(this.$route.params);
    this.business_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();
    //nyd
    //if the _user is not there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Business Manage Photos",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Buinesses",
          disabled: false,
          href: "/owner/businesses/",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/businesses/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/businesses/list/view/" + this.business_id,
        },
        {
          text: "Photos",
          disabled: true,
          href:
            "/owner/businesses/list/view/" +
            this.business_id +
            "/gallery/manage",
        },
      ],
      navbar_cols: 3,
    });
    this.load_business(this.business_id);

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_view_gallery_edit_form", options);
  },
};
</script>